import React, { useEffect } from 'react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import GLightbox from 'glightbox';
import './Clients.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'glightbox/dist/css/glightbox.min.css';

const Clients = () => {
  useEffect(() => {
    GLightbox({
      selector: '.glightbox-client',
      touchNavigation: true,
      loop: true,
    });
  }, []);

  const images = [1, 2, 3, 4, 5, 6].map((i) => `/assets/img/clients/client-${i}.jpeg`);

  return (
    <section id="clients" className="clients section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Featured in</h2>
        <p>Brands and platforms that have featured us.</p>
      </div>

      <div className="clients-slider" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            1024: { slidesPerView: 3 },
            600: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <a href={src} className="glightbox-client">
                <img src={src} className="img-fluid" alt={`Client ${index + 1}`} />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Clients;  